
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import "./Signdown.css";

function Signdown() {
  const navigate = useNavigate();
  const navigateTo = (path) => {
    navigate(path);
  };
  
  return (
    <div className="SU-signup-container">
      <h1 className="SU-supheader-title">iSpeakWell</h1>
      <h5 className="SU-tagline">
        Become a member of the iSpeakWell crew.
      </h5>
      <h3>Practice Speaking with Real Humans & AI.</h3>
      <div className="SD-container">
        <h1>Sign‑Ups Are Temporarily Closed</h1>
        <p>
            We’re doing some behind‑the‑scenes work to scale our service.
            Please check back in a little while!
        </p>
        <Link to="/" className="SD-home-link">
            ← Return to Home
        </Link>
      </div>
      <div className="SU-links-section">
        <button
          className="PWRS-link-button"
          onClick={() => navigateTo("/about")}
        >
          About
        </button>
        <button
          className="SU-link-button"
          onClick={() => navigateTo("/careers")}
        >
          Careers
        </button>
        <button
          className="SU-link-button"
          onClick={() => navigateTo("/tokens")}
        >
          Tokens
        </button>
        <button
          className="SU-link-button"
          onClick={() => navigateTo("/contactus")}
        >
          Contact Us
        </button>
        <button className="SU-link-button" onClick={() => navigateTo("/login")}>
          Login
        </button>
      </div>
    </div>
  );
}

export default Signdown;
